import React from 'react';
import { useTranslation } from 'react-i18next';

export default function WarehouseElem({ warehouseCode }: { warehouseCode: string }) {
    const { t } = useTranslation();

    return <span>{t(`warehouse.warehouses.${warehouseCode}`)}</span>;
}
